 <ng-container *ngIf="!isSubmitted && !immediateFeedBackRequired">
   <div class="new-options">
     <div class="draggable-input">
       <div *ngFor="let opt of options;index as i"
         class="draggable-input--match d-block d-md-flex align-items-center justify-content-between">
         <div class="me-md-2">{{opt.text}}</div>
         <div class="form-control--selectoption">
           <select [(ngModel)]="value[i]" (change)='onValueChange(i)' class="form-control">
             <option disabled hidden [value]="''">Choose an option</option>
             <option *ngFor="let opt of optionsToDisplay;index as j" [value]="opt"> {{opt}}</option>
           </select>
         </div>
       </div>
     </div>
   </div>
 </ng-container>
 <ng-container *ngIf="!isSubmitted && immediateFeedBackRequired">
   <div class="new-options">
     <div class="draggable-input">
       <div *ngFor="let opt of options;index as i"
         class="draggable-input--match d-block d-md-flex align-items-center justify-content-between">
         <div class="me-md-2">{{opt.text}}</div>
         <div class="form-control--selectoption"
           [class.new-options--wrong-answer]="value[i] != opt.mfAnswer && questionChecked"
           [class.new-options--right-answer]="value[i] == opt.mfAnswer && questionChecked"
           [class.new-options--has-feedback]="questionChecked && value[i] && opt.feedback">
           <select [(ngModel)]="value[i]" (change)='onValueChange(i)' [attr.disabled]="questionChecked ? '' : null"
             class="form-control">
             <option disabled hidden [value]="''">Choose an option</option>
             <option *ngFor="let opt of optionsToDisplay;index as j" [value]="opt"> {{opt}}</option>
           </select>
           <div *ngIf="value[i] != opt.mfAnswer &&  questionChecked && value[i] && opt.feedback" class="has-feedback">
             <span class="has-feedback--icon">
               <span>?</span>
             </span>
             <div class="has-feedback--dropdown">
               {{opt.feedback}}
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </ng-container>

 <ng-container *ngIf="isSubmitted">
   <div class="new-options">
     <div class="draggable-input">
       <div *ngFor="let opt of options;index as i"
         class="draggable-input--match d-block d-md-flex align-items-center justify-content-between">
         <div class="me-md-2">{{opt.text}}</div>
         <div class="draggable-input--blank" [class.empty]="!answers[i]"
           [class.new-options--wrong-answer]="!corrects[i] && answers[i]"
           [class.new-options--right-answer]="corrects[i] && answers[i]"
           [class.new-options--has-feedback]="isAnyQuestionIncorrect && answers[i] && opt.feedback">
           {{answers[i]||'Not Answered'}}
           <div *ngIf="!corrects[i] && answers[i] && opt.feedback" class="has-feedback">
             <span class="has-feedback--icon">
               <span>?</span>
             </span>
             <div class="has-feedback--dropdown">
               {{opt.feedback}}
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </ng-container>
